import get from 'lodash/get';
import { useSelect } from '../useSelect';

const initialAsyncState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
  errorCode: '',
};

export const useAsync = (actionType) => {
  return (
    useSelect((state) => get(state, `async.${actionType}`)) || initialAsyncState
  );
};
